<template>
    <section class="content" style="margin-left:110px">

        <div class="main_table" style="overflow-x:auto;width: 992px;">

        <table cellspacing="0" cellpadding="1" border="0" style="width: 100%;">


	<!--header start-->
	<!--header start-->
	<!--header start-->
	<div class="header_top">

     <tr>
     	 <td style="font-size: 16px; border:1px solid #000; width: 50%; padding-left: 10px;">Location Name: <b>{{techchecklist.siteName}}</b></td>
     	 <td style="font-size: 16px; border:1px solid #000; text-align: right;padding-right: 10px;">Doc No: <b>1</b> </td>
     </tr>
     <!-- next tr -->
     <tr>
		<td colspan="2" style="font-size: 24px; border:1px solid #000; width: 56%; padding-left: 10px;text-align: center;font-weight: bold;">TECHNICIAN LOG BOOK/CHECK LIST</td>

	 </tr>
	 
	 		</div>
	<!--header end-->
	<!--header end-->
	<!--header end-->
	

	
	<tr>
		<td colspan="2" style="padding: 0px;">
			<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
				<tr>
			<td style="font-size: 16px; width:50%;border:1px solid #000; width: 50%; padding-left: 10px;">DATE: <b style="margin-left:20px">{{this.selectedDate}} </b></td>
     	 <td style="font-size: 16px; border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">SHIFT: <b style="margin-left:20px">{{techchecklist.shift}} </b> </td>
     	 <td style="font-size: 16px; border:1px solid #000; text-align: left;padding-left: 10px;">SI.No.<b>{{"1"}}</b></td>
				</tr>
			</table>
		</td>
     	 
     </tr>	
     <!-- next	 -->
     	<tr>
		<td colspan="2" style="padding: 0px;">
			<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
				<tr>
					<td style="font-size: 16px; font-weight:bold; border:1px solid #000; text-align: center;padding-left: 10px;">S.NO.</td>

					<td style="font-size: 16px; font-weight:bold;  border:1px solid #000;width: 40%; text-align: center;padding-left: 10px;">TASK TO BE CARRIED OUT</td>
					<td style="font-size: 16px;text-align: center; font-weight:bold;  width:50%;border:1px solid #000; width: 50%; padding-left: 10px;">REMARKS</td>
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px; font-weight: bold;">1</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;"> DG Set:</td>
				
     	              <td rowspan="2" style="font-size: 16px;text-align: left;  width:50%;border:1px solid #000; width: 50%; padding-left: 10px;font-weight: bold;">Abnormality/Breakdown reported to (if any,in Dispenser,Cascade,DG set,UPS,Air Compressor,etc):							
							</td>
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">1.1</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Diesel/Water in DG set checked<b style="margin-left:80px"> {{(techchecklist.dgSet.subList[0].value == "true") ? "Yes" : (techchecklist.dgSet.subList[0].value == "false") ? "No" : "Na"}} </b> </td>
					
     	 
				</tr>
				<!-- next -->


			</table>
		</td>
     	 
     </tr>	
     <!-- next -->
     	<tr>
		<td colspan="2" style="padding: 0px;">
			<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
		
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">1.2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;"> DG set started once in shift	<b style="margin-left:112px"> {{(techchecklist.dgSet.subList[1].value == "true") ? "Yes" : (techchecklist.dgSet.subList[1].value == "false") ? "No" : "Na"}} </b></td>
				
     	              <td rowspan="5" style="font-size: 16px;text-align: left;  width:50%;border:1px solid #000; width: 50%; padding-left: 10px;">
							</td>
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;font-weight: bold;">2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;">Air Compressor:</td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">2.1</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Air compressor filter cleaned <b style="margin-left:102px">	{{(techchecklist.airCompressor.subList[0].value == "true") ? "Yes" : (techchecklist.airCompressor.subList[0].value == "false") ? "No" : "Na"}} </b></td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">2.2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Air compressor oil level checked <b style="margin-left:75px">	 {{(techchecklist.airCompressor.subList[1].value == "true") ? "Yes" : (techchecklist.airCompressor.subList[1].value == "false") ? "No" : "Na"}} </b></td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">2.3</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Air compressor receiver drained <b style="margin-left:77px">	 {{(techchecklist.airCompressor.subList[2].value == "true") ? "Yes" : (techchecklist.airCompressor.subList[2].value == "false") ? "No" : "Na"}} </b></td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px; font-weight: bold;">3</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;">Dispenser:					</td>
				
     	              <td  style="font-size: 16px;text-align: left;  width:50%;border:1px solid #000; width: 50%; padding-left: 10px;font-weight: bold;">Nature of Abnormality/Breakdown :  	</td>
				</tr>
				<!-- next -->
				

			</table>
		</td>
     	 
     </tr>	
     <!-- next -->
 	
		<td colspan="2" style="padding: 0px;">
			<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
		
				<!-- next -->
				<tr>
					<td rowspan="3" style="font-size: 16px;text-align: left;  width:50%;border:1px solid #000; width: 10%; padding-left: 10px;">3.1
							</td>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px; width: 40%;border-bottom: 0px;">Working Condition :</td>

					<td rowspan="6" style="font-size: 16px;   border:1px solid #000;width: 50%; text-align: left;padding-left: 10px;">{{techchecklist.remarks.subList[0].natureOfAbnormality}}</td>
				
     	              
				</tr>
				<!-- next -->
					<!-- td colm -->
					<!-- td colm -->
					<!-- td colm -->
				<!-- <td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">
								<tr>
								<td style="padding: 0px;">
								<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
									<tr>
										<td style="font-size: 16px;  border:1px solid #000; border-top:0;border-right:0;width: 45%;padding-left: 10px;">Dispenser - 1;</td>
										<td style="font-size: 16px; width: 65%; border:1px solid #000;border-top:0;border-left:0;">Side - A</td>
									</tr>
								</table>
								</td>
								</tr>

				</td> -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;">
						<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
									<tr>
										<td style="font-size: 16px;  border:1px solid #000; border-top:0;border-right:0;width: 45%;padding-left: 10px;border-left: 0px;border-top: 0px;">Dispenser - 1</td>
										<td style="font-size: 16px; width: 65%; border:1px solid #000;border-top:0;border-left:0;border-right: 0px;border-left: 0px;">Side - A</td>
									</tr>
									<!-- next -->
									<tr>
										<td colspan="2" style="font-size: 16px;  border:1px solid #000; border-top:0;text-align: center;padding-left: 10px;border-right: 0px;border-left: 0px;border-bottom: 0px;">Side - B</td>
										
									</tr>
									

						</table>
						
					</td>

					
     	 

				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;">
						<table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
									<tr>
										<td style="font-size: 16px;  border:1px solid #000; border-top:0;border-right:0;width: 45%;padding-left: 10px;border-left: 0px;border-top: 0px;">Dispenser - 2</td>
										<td style="font-size: 16px; width: 65%; border:1px solid #000;border-top:0;border-left:0;border-right: 0px;border-left: 0px;">Side - A</td>
									</tr>
									<!-- next -->
									<tr>
										<td colspan="2" style="font-size: 16px;  border:1px solid #000; border-top:0;text-align: center;padding-left: 10px;border-right: 0px;border-left: 0px;border-bottom: 0px;">Side - B</td>
										
									</tr>
									

						</table>
						
					</td>

					
     	 
				</tr>
				<!-- next -->
			
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">3.2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Dispenser filters drained	  <b style="margin-left:130px">	{{(techchecklist.dispenser.subList[0].value == "true") ? "Yes" : (techchecklist.dispenser.subList[0].value == "false") ? "No" : "Na"}}		</b>	</td>
				
     	             
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">3.3</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Dispenser nozzles checked and cleaned  <b style="margin-left:16px"> {{(techchecklist.dispenser.subList[1].value == "true") ? "Yes" : (techchecklist.dispenser.subList[1].value == "false") ? "No" : "Na"}} </b></td>
				
     	             
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">3.4</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Condition of dispenser seals  <b style="margin-left:100px"> {{(techchecklist.dispenser.subList[2].value == "true") ? "Yes" : (techchecklist.dispenser.subList[2].value == "false") ? "No" : "Na"}} </b></td>
				
     	            
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">3.5</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Ensure two hour reading of dispensers  <b style="margin-left:27px">{{(techchecklist.dispenser.subList[3].value == "true") ? "Yes" : (techchecklist.dispenser.subList[3].value == "false") ? "No" : "Na"}} </b></td>
				<td style="font-size: 16px;   border:1px solid #000;width: 50%; text-align: left;padding-left: 10px;font-weight: bold;">Cause: </td>
     	              
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;font-weight: bold;">4</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;">Cascade:</td>
				
     	              <td rowspan="4" style="font-size: 16px;text-align: left;  width:50%;border:1px solid #000; width: 50%; padding-left: 10px;">{{techchecklist.remarks.subList[1].cause}}</td>
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">4.1</td>

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check cascade leakage,if any <b style="margin-left:88px">{{(techchecklist.cascade.subList[0].value == "true") ? "Yes" : (techchecklist.cascade.subList[0].value == "false") ? "No" : "Na"}}</b>	</td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;font-weight: bold;">5</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;">Electrical / UPS</td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">5.1</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check power supply <b style="margin-left:156px">{{(techchecklist.electrical.subList[0].value == "true") ? "Yes" : (techchecklist.electrical.subList[0].value == "false") ? "No" : "Na"}} </b></td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">5.2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Energy meter/UPS seals <b style="margin-left:125px">{{(techchecklist.electrical.subList[1].value == "true") ? "Yes" : (techchecklist.electrical.subList[1].value == "false") ? "No" : "Na"}}</b></td>
					 <td  style="font-size: 16px;text-align: left;  width:50%;border:1px solid #000; width: 50%; padding-left: 10px;font-weight: bold;">Action Taken : </td>
					
     	 
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">5.3</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Electrical Room lock checked <b style="margin-left:91px">{{(techchecklist.electrical.subList[2].value == "true") ? "Yes" : (techchecklist.electrical.subList[2].value == "false") ? "No" : "Na"}}</b></td>

					<td rowspan="11" style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">{{techchecklist.remarks.subList[2].actionTaken}}</td>
				
     	             
				</tr>
				<!-- next -->
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;font-weight: bold;">6</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;">General:</td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">6.1</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Tools handed over <b style="margin-left:169px">{{(techchecklist.general.subList[0].value == "true") ? "Yes" : (techchecklist.general.subList[0].value == "false") ? "No" : "Na"}}</b></td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">6.2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Waste cloth availability on the station <b style="margin-left:38px">{{(techchecklist.general.subList[1].value == "true") ? "Yes" : (techchecklist.general.subList[1].value == "false") ? "No" : "Na"}}</b></td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">6.3</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check DSM duty handed over <b style="margin-left:86px">{{(techchecklist.general.subList[2].value == "true") ? "Yes" : (techchecklist.general.subList[2].value == "false") ? "No" : "Na"}}</b></td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">6.4</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Take over log book <b style="margin-left:164px">{{(techchecklist.general.subList[3].value == "true") ? "Yes" : (techchecklist.general.subList[3].value == "false") ? "No" : "Na"}}</b></td>
				
     	             
				</tr>
				<!-- <tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;font-weight: bold;">7</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;font-weight: bold;">HCV</td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">7.1</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check availability of Fire Extinguisher</td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">7.2</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check front camera working </td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">7.3</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check back camera working</td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">7.4</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check GPS working</td>
				
     	             
				</tr>
				<tr>
					<td style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;">7.5</td>


					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Check Cascade leakage,if any</td>
				
     	             
				</tr> -->
				<!-- next -->
				<tr>
					<td rowspan="5" style="font-size: 16px;  border:1px solid #000; text-align: left;padding-left: 10px;font-weight: bold;">8</td>

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Assets:</td>
				
     	             
				</tr>
				<tr>
					
					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">First Aid Box <b style="margin-left:208px">{{(techchecklist.assets.subList[0].value == "true") ? "Yes" : (techchecklist.assets.subList[0].value == "false") ? "No" : "Na"}} </b></td>
				
     	             
				</tr>
				
				<tr>
					

					<td style="font-size: 16px;   border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Tool Box  <b style="margin-left:236px">{{(techchecklist.assets.subList[1].value == "true") ? "Yes" : (techchecklist.assets.subList[1].value == "false") ? "No" : "Na"}} </b></td>
				
     	             
				</tr>
				
				<tr>
					

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Adapter/Remote  <b style="margin-left:180px">{{(techchecklist.assets.subList[2].value == "true") ? "Yes" : (techchecklist.assets.subList[2].value == "false") ? "No" : "Na"}} </b></td>
				
     	             
				</tr>
				
				<tr>
					

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Oil/Coolant/Diesel  <b style="margin-left:168px">{{(techchecklist.assets.subList[3].value == "true") ? "Yes" : (techchecklist.assets.subList[3].value == "false") ? "No" : "Na"}} </b></td>
				
     	             
				</tr>
				<!-- <tr>
					

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: left;padding-left: 10px;">Fire Extinguisher available</td>
				
     	             
				</tr>
				<tr>
					

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: center;padding-left: 10px;">Type_____________Kgs(        Nos)</td>
				
     	             
				</tr>
				<tr>
					

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: center;padding-left: 10px;">Type_____________Kgs(        Nos)</td>
				
     	             
				</tr>
				<tr>
					

					<td style="font-size: 16px;border:1px solid #000;width: 40%; text-align: center;padding-left: 10px;">Type_____________Kgs(        Nos)</td>
				
     	             
				</tr> -->

				<!-- next full tr -->
				<tr>
				
					<td colspan="3" style="font-size: 16px;   padding:50px 0px; border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;"><b>Details of Breakdown/power cut & DG set running hours : {{techchecklist.additionalInfo.subList[0].dgSetRunningHour}} </b></td>
				
				</tr>
				
				<!-- next full tr -->
				<tr>
				
					<td colspan="3" style="font-size: 16px; padding:50px 0px;  border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;"><b>Instructions received from control room in the shift : {{techchecklist.additionalInfo.subList[1].instructionReceived}}</b></td>
				
				</tr>
				
				<!-- next full tr -->
				<tr>
				
					<td colspan="3" style="font-size: 16px;  padding:50px 0px;  border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;"><b>Other Information for next shift Technician : {{techchecklist.additionalInfo.subList[2].otherInformation}}</b> </td>
				
				</tr>
				<tr>
				
					<td colspan="3" style="font-size: 16px; border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;height: 21px;"></td>
				
				</tr>
				<tr>
				
					<td colspan="3" style="font-size: 16px;  border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;font-weight: bold;">Technician-In-Charge  </td>
				
				</tr>
				<tr>
				
					<td colspan="3" style="font-size: 16px;  border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;">Name :<b>{{techchecklist.operatorName}}</b></td>
				
				</tr>
				<tr>
				
					<td colspan="3" style="font-size: 16px; border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;height: 21px;"></td>
				
				</tr>
				<tr>
				
					<td colspan="3" style="font-size: 16px; border:1px solid #000;width: 100%; text-align: left;padding-left: 10px;">Signature : {{techchecklist.sign}}</td>
				
				</tr>
			</table>
		</td>
     	 
     
     <!-- next -->
				

			</table>
			<br>
			<div class="col-sm-13 text-right">
				<router-link :to="{ name: 'OperatorReport' }">
					<button class="mr-5 btn btn-primary" type="button">Cancel</button>
				</router-link>
			</div>
			
		</div>
		
    </section>
</template>

<script>
import { formService, eventBus} from '../../../services'
import { EVENTS } from '../../../config'
import swal from 'sweetalert2'
import { USER_ROLES } from '../../../config';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
    name : 'ViewOperatorReport',
    data () {
       return {
           USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
			techchecklist :{},
			selectedDate:'',
        }
    },
    mounted : function(){
        this.getReport()
    },
    methods:{
        getReport () {
            this.$techchecklistDataRepository.find(this.$route.params._id)
            .then((response) => {
				this.techchecklist = response.data;
				this.selectedDate = (response.data.selectedDate && moment(response.data.selectedDate).format('DD-MM-YYYY hh:mm A'))
            })
            
        },
    }

}
</script>


// WEBPACK FOOTER //
// ViewOperatorReport.vue?5c3e9826